console.log('Global JS loaded');
import './setup/jquery-global';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'slick-carousel';

import './custom';
import './footer';
